import useQueryParam from './useQueryParam';

const useAmount = (): number | undefined => {
    const amount = useQueryParam('amount');
    if (amount) {
        return Number(amount);
    }
    return undefined;
};
export default useAmount;
